import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const location  = useLocation();
  const from      = location.state?.from?.pathname || '/';

  return (
    <div className="flex min-h-screen items-center justify-center bg-parchment px-4">
      <div className="w-full max-w-md">
        {/* Logo / Title */}
        <div className="mb-8 text-center">
          <span className="flex items-center justify-center gap-3 mb-3">
            <span className="relative flex h-3 w-3 items-center justify-center">
              <span className="animate-impact-pulse absolute inline-flex h-full w-full rounded-full bg-[#c0392b] opacity-35" />
              <span className="relative inline-flex h-3 w-3 rounded-full bg-[#c0392b]" />
            </span>
            <span className="text-[28px] font-normal tracking-[-0.025em] text-ink leading-none">impact</span>
          </span>
          <p className="mt-2 text-sm text-neutral-500">Sign in to continue</p>
        </div>

        <div className="rounded-2xl border border-neutral-200 bg-paper p-8 shadow-sm text-center">
          <p className="mb-6 text-sm text-neutral-500">
            You'll be taken to the Impact portal to sign in, then redirected back here.
          </p>
          <button
            onClick={() => login(from)}
            className="w-full rounded-lg bg-[#003cc5] py-2.5 font-semibold text-parchment transition hover:bg-[#0036b1]"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}
